import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface IrcInputProps {
  onIrcChange: (value: string) => void;
  ircValue: string;
  isEnabled: boolean;
}

export const IrcInput: React.FC<IrcInputProps> = ({
  onIrcChange,
  ircValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="IRC"
      label="Enter IRC details:"
      placeholder="Enter International Residential Code information..."
      value={ircValue}
      onChange={onIrcChange}
      isEnabled={isEnabled}
    />
  );
};
